<template>
  <div class="pro-form-est">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntIcone='false' :cpntTamanho='5'></RF-Status>
    
    <!-- MOSTRA A PAGINA -->
    <template v-else>
      <div class="campos">
        <App-Toggles :data-time="time" class="pro-form-det--est_calc"
          :cpntStatus='campos.est_calc.status'
          :cpntId='campos.est_calc.id'
          :cpntClassDivField='campos.est_calc.classDivField'
          :cpntNome='campos.est_calc.nome'
          :cpntValue='campos.est_calc.value'
          :cpntMostrar='campos.est_calc.mostrar'
          :cpntMensagem='campos.est_calc.mensagem'
          :cpntMensagemTipo='campos.est_calc.mensagemTipo'
          :cpntOn='campos.est_calc.on'
          :cpntOff='campos.est_calc.off'
          :cpntExplica='campos.est_calc.explica'
          :cpntWidth='campos.est_calc.width'
          :cpntTabIndex='campos.est_calc.tabIndex'
          :cpntDisabled='campos.est_calc.disabled'
          :cpntOnChange='campos.est_calc.onChange'
          :cpntOnBlur='campos.est_calc.onBlur'
          ref='est_calc'
        ></App-Toggles>

        <App-Input :data-time="time" class="pro-form-det--qtde_min" v-if="campos.est_calc.value === true"
          :cpntStatus='campos.qtde_min.status'
          :cpntId='campos.qtde_min.id'
          :cpntTabIndex='campos.qtde_min.tabIndex'
          :cpntClassDivField='campos.qtde_min.classDivField'
          :cpntNome='campos.qtde_min.nome'
          :cpntValue='campos.qtde_min.value'
          :cpntAutoComplete='campos.qtde_min.autocomplete'
          :cpntMask='campos.qtde_min.mask'
          :cpntOptionInicialNome='campos.qtde_min.optionInicialNome'
          :cpntOptionInicialValue='campos.qtde_min.optionInicialValue'
          :cpntDisabled='campos.qtde_min.disabled'
          :cpntMostrar='campos.qtde_min.mostrar'
          :cpntExplica='campos.qtde_min.explica'
          :cpntAutoFocus='campos.qtde_min.autofocus'
          :cpntMensagem='campos.qtde_min.mensagem'
          :cpntMensagemTipo='campos.qtde_min.mensagemTipo'
          :cpntPlaceholder='campos.qtde_min.placeholder'
          :cpntPosicionar='campos.qtde_min.posicionar'
          :cpntOnChange='campos.qtde_min.onChange'
          :cpntOnBlur='campos.qtde_min.onBlur'
          ref='qtde_min'
        ></App-Input>
      </div>

      <template v-if="campos.est_calc.value === true">
        <div class="demonstrativo">
          <div class="titulo">
            DEMONSTRATIVO DE CÁLCULO DE ESTOQUE ATUAL
          </div>

          <div class="calculo passo-1">
            <div class="parenteses">(</div>

            <App-Input :data-time="time" class="pro-form-det--est_ajuste"
              :cpntStatus='campos.est_ajuste.status'
              :cpntId='campos.est_ajuste.id'
              :cpntTabIndex='campos.est_ajuste.tabIndex'
              :cpntClassDivField='campos.est_ajuste.classDivField'
              :cpntNome='campos.est_ajuste.nome'
              :cpntValue='campos.est_ajuste.value'
              :cpntAutoComplete='campos.est_ajuste.autocomplete'
              :cpntMask='campos.est_ajuste.mask'
              :cpntOptionInicialNome='campos.est_ajuste.optionInicialNome'
              :cpntOptionInicialValue='campos.est_ajuste.optionInicialValue'
              :cpntDisabled='campos.est_ajuste.disabled'
              :cpntMostrar='campos.est_ajuste.mostrar'
              :cpntExplica='campos.est_ajuste.explica'
              :cpntAutoFocus='campos.est_ajuste.autofocus'
              :cpntMensagem='campos.est_ajuste.mensagem'
              :cpntMensagemTipo='campos.est_ajuste.mensagemTipo'
              :cpntPlaceholder='campos.est_ajuste.placeholder'
              :cpntPosicionar='campos.est_ajuste.posicionar'
              :cpntOnChange='campos.est_ajuste.onChange'
              :cpntOnBlur='campos.est_ajuste.onBlur'
              ref='est_ajuste'
            ></App-Input>

            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-plus'"></App-Icone>
            </div>

            <App-Input :data-time="time" class="pro-form-det--qtde_com"
              :cpntStatus='campos.qtde_com.status'
              :cpntId='campos.qtde_com.id'
              :cpntTabIndex='campos.qtde_com.tabIndex'
              :cpntClassDivField='campos.qtde_com.classDivField'
              :cpntNome='campos.qtde_com.nome'
              :cpntValue='campos.qtde_com.value'
              :cpntAutoComplete='campos.qtde_com.autocomplete'
              :cpntMask='campos.qtde_com.mask'
              :cpntOptionInicialNome='campos.qtde_com.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_com.optionInicialValue'
              :cpntDisabled='campos.qtde_com.disabled'
              :cpntMostrar='campos.qtde_com.mostrar'
              :cpntExplica='campos.qtde_com.explica'
              :cpntAutoFocus='campos.qtde_com.autofocus'
              :cpntMensagem='campos.qtde_com.mensagem'
              :cpntMensagemTipo='campos.qtde_com.mensagemTipo'
              :cpntPlaceholder='campos.qtde_com.placeholder'
              :cpntPosicionar='campos.qtde_com.posicionar'
              :cpntOnChange='campos.qtde_com.onChange'
              :cpntOnBlur='campos.qtde_com.onBlur'
              ref='qtde_com'
            ></App-Input>

            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-plus'"></App-Icone>
            </div>

            <App-Input :data-time="time" class="pro-form-det--qtde_fab"
              :cpntStatus='campos.qtde_fab.status'
              :cpntId='campos.qtde_fab.id'
              :cpntTabIndex='campos.qtde_fab.tabIndex'
              :cpntClassDivField='campos.qtde_fab.classDivField'
              :cpntNome='campos.qtde_fab.nome'
              :cpntValue='campos.qtde_fab.value'
              :cpntAutoComplete='campos.qtde_fab.autocomplete'
              :cpntMask='campos.qtde_fab.mask'
              :cpntOptionInicialNome='campos.qtde_fab.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_fab.optionInicialValue'
              :cpntDisabled='campos.qtde_fab.disabled'
              :cpntMostrar='campos.qtde_fab.mostrar'
              :cpntExplica='campos.qtde_fab.explica'
              :cpntAutoFocus='campos.qtde_fab.autofocus'
              :cpntMensagem='campos.qtde_fab.mensagem'
              :cpntMensagemTipo='campos.qtde_fab.mensagemTipo'
              :cpntPlaceholder='campos.qtde_fab.placeholder'
              :cpntPosicionar='campos.qtde_fab.posicionar'
              :cpntOnChange='campos.qtde_fab.onChange'
              :cpntOnBlur='campos.qtde_fab.onBlur'
              ref='qtde_fab'
            ></App-Input>

            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-plus'"></App-Icone>
            </div>

            <App-Input :data-time="time" class="pro-form-det--qtde_dev_cli"
              :cpntStatus='campos.qtde_dev_cli.status'
              :cpntId='campos.qtde_dev_cli.id'
              :cpntTabIndex='campos.qtde_dev_cli.tabIndex'
              :cpntClassDivField='campos.qtde_dev_cli.classDivField'
              :cpntNome='campos.qtde_dev_cli.nome'
              :cpntValue='campos.qtde_dev_cli.value'
              :cpntAutoComplete='campos.qtde_dev_cli.autocomplete'
              :cpntMask='campos.qtde_dev_cli.mask'
              :cpntOptionInicialNome='campos.qtde_dev_cli.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_dev_cli.optionInicialValue'
              :cpntDisabled='campos.qtde_dev_cli.disabled'
              :cpntMostrar='campos.qtde_dev_cli.mostrar'
              :cpntExplica='campos.qtde_dev_cli.explica'
              :cpntAutoFocus='campos.qtde_dev_cli.autofocus'
              :cpntMensagem='campos.qtde_dev_cli.mensagem'
              :cpntMensagemTipo='campos.qtde_dev_cli.mensagemTipo'
              :cpntPlaceholder='campos.qtde_dev_cli.placeholder'
              :cpntPosicionar='campos.qtde_dev_cli.posicionar'
              :cpntOnChange='campos.qtde_dev_cli.onChange'
              :cpntOnBlur='campos.qtde_dev_cli.onBlur'
              ref='qtde_dev_cli'
            ></App-Input>

            <div class="parenteses">)</div>
          </div>

          <div class="calculo simbolos passo-2">
            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-minus'"></App-Icone>
            </div>
          </div>

          <div class="calculo passo-3">
            <div class="parenteses">(</div>

            <App-Input :data-time="time" class="pro-form-det--qtde_con"
              :cpntStatus='campos.qtde_con.status'
              :cpntId='campos.qtde_con.id'
              :cpntTabIndex='campos.qtde_con.tabIndex'
              :cpntClassDivField='campos.qtde_con.classDivField'
              :cpntNome='campos.qtde_con.nome'
              :cpntValue='campos.qtde_con.value'
              :cpntAutoComplete='campos.qtde_con.autocomplete'
              :cpntMask='campos.qtde_con.mask'
              :cpntOptionInicialNome='campos.qtde_con.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_con.optionInicialValue'
              :cpntDisabled='campos.qtde_con.disabled'
              :cpntMostrar='campos.qtde_con.mostrar'
              :cpntExplica='campos.qtde_con.explica'
              :cpntAutoFocus='campos.qtde_con.autofocus'
              :cpntMensagem='campos.qtde_con.mensagem'
              :cpntMensagemTipo='campos.qtde_con.mensagemTipo'
              :cpntPlaceholder='campos.qtde_con.placeholder'
              :cpntPosicionar='campos.qtde_con.posicionar'
              :cpntOnChange='campos.qtde_con.onChange'
              :cpntOnBlur='campos.qtde_con.onBlur'
              ref='qtde_con'
            ></App-Input>

            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-plus'"></App-Icone>
            </div>

            <App-Input :data-time="time" class="pro-form-det--qtde_dev_for"
              :cpntStatus='campos.qtde_dev_for.status'
              :cpntId='campos.qtde_dev_for.id'
              :cpntTabIndex='campos.qtde_dev_for.tabIndex'
              :cpntClassDivField='campos.qtde_dev_for.classDivField'
              :cpntNome='campos.qtde_dev_for.nome'
              :cpntValue='campos.qtde_dev_for.value'
              :cpntAutoComplete='campos.qtde_dev_for.autocomplete'
              :cpntMask='campos.qtde_dev_for.mask'
              :cpntOptionInicialNome='campos.qtde_dev_for.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_dev_for.optionInicialValue'
              :cpntDisabled='campos.qtde_dev_for.disabled'
              :cpntMostrar='campos.qtde_dev_for.mostrar'
              :cpntExplica='campos.qtde_dev_for.explica'
              :cpntAutoFocus='campos.qtde_dev_for.autofocus'
              :cpntMensagem='campos.qtde_dev_for.mensagem'
              :cpntMensagemTipo='campos.qtde_dev_for.mensagemTipo'
              :cpntPlaceholder='campos.qtde_dev_for.placeholder'
              :cpntPosicionar='campos.qtde_dev_for.posicionar'
              :cpntOnChange='campos.qtde_dev_for.onChange'
              :cpntOnBlur='campos.qtde_dev_for.onBlur'
              ref='qtde_dev_for'
            ></App-Input>

            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-plus'"></App-Icone>
            </div>

            <App-Input :data-time="time" class="pro-form-det--qtde_ven"
              :cpntStatus='campos.qtde_ven.status'
              :cpntId='campos.qtde_ven.id'
              :cpntTabIndex='campos.qtde_ven.tabIndex'
              :cpntClassDivField='campos.qtde_ven.classDivField'
              :cpntNome='campos.qtde_ven.nome'
              :cpntValue='campos.qtde_ven.value'
              :cpntAutoComplete='campos.qtde_ven.autocomplete'
              :cpntMask='campos.qtde_ven.mask'
              :cpntOptionInicialNome='campos.qtde_ven.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_ven.optionInicialValue'
              :cpntDisabled='campos.qtde_ven.disabled'
              :cpntMostrar='campos.qtde_ven.mostrar'
              :cpntExplica='campos.qtde_ven.explica'
              :cpntAutoFocus='campos.qtde_ven.autofocus'
              :cpntMensagem='campos.qtde_ven.mensagem'
              :cpntMensagemTipo='campos.qtde_ven.mensagemTipo'
              :cpntPlaceholder='campos.qtde_ven.placeholder'
              :cpntPosicionar='campos.qtde_ven.posicionar'
              :cpntOnChange='campos.qtde_ven.onChange'
              :cpntOnBlur='campos.qtde_ven.onBlur'
              ref='qtde_ven'
            ></App-Input>

            <div class="parenteses">)</div>
          </div>

          <div class="calculo simbolos">
            <div class="sinais">
              <App-Icone :cpntTipo="'fas fa-equals'"></App-Icone>
            </div>
          </div>

          <div class="calculo resultado">
            <App-Input :data-time="time" class="pro-form-det--qtde_est"
              :cpntStatus='campos.qtde_est.status'
              :cpntId='campos.qtde_est.id'
              :cpntTabIndex='campos.qtde_est.tabIndex'
              :cpntClassDivField='campos.qtde_est.classDivField'
              :cpntNome='campos.qtde_est.nome'
              :cpntValue='campos.qtde_est.value'
              :cpntAutoComplete='campos.qtde_est.autocomplete'
              :cpntMask='campos.qtde_est.mask'
              :cpntOptionInicialNome='campos.qtde_est.optionInicialNome'
              :cpntOptionInicialValue='campos.qtde_est.optionInicialValue'
              :cpntDisabled='campos.qtde_est.disabled'
              :cpntMostrar='campos.qtde_est.mostrar'
              :cpntExplica='campos.qtde_est.explica'
              :cpntAutoFocus='campos.qtde_est.autofocus'
              :cpntMensagem='campos.qtde_est.mensagem'
              :cpntMensagemTipo='campos.qtde_est.mensagemTipo'
              :cpntPlaceholder='campos.qtde_est.placeholder'
              :cpntPosicionar='campos.qtde_est.posicionar'
              :cpntOnChange='campos.qtde_est.onChange'
              :cpntOnBlur='campos.qtde_est.onBlur'
              ref='qtde_est'
            ></App-Input>
          </div>

          <App-Button :cpntClass="'btn btn-default btn-sm'" @onClick="proFormEstoqueAjustarEstoque" title="Só é possível ajustar o estoque para produtos já cadastrados.">
            Ajustar Estoque
          </App-Button>

          
        </div>

        <!-- <div class="aviso" v-if="Number(campos.qtde_est.value)  !== Number(campos.qtde_est.valueIni)">
          <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
          <b style="margin-left: 5px;">ATENÇÃO</b>
          <br/>
          <br/>
          A alteração só será realizada após clicar em Salvar ou Atualizar.
          <br/>
          <br/>
          O campo <u>Qtde. Inicial</u> será alterado automaticamente para {{ proFormEstoqueCalcularNovaQtdeInicial() }}.
        </div> -->
      </template>
    </template>

    <App-Produto-Formulario-Estoque-Ajuste v-if="ajustarEst === true"
    :cpntHashId="cpntHashId"
    :cpntId="cpntId"
    :cpntEditarVarios="cpntEditarVarios"
    :cpntDados="dadosEst"
    :cpntValorAjusteNovo="cpntValorAjusteNovo"
    :cpntFecharFormulario="proFormEstoqueAjustarEstoque"
    @ATUALIZAR_INFORMACOES_EXTERNAS="() => { proFormAtualizarInfoExterna() }"
    @PRODUTO_AJUSTE_ESTOQUE="proFormEstoqueAjustarSalvar"
    ref="estoque_ajuste"
    ></App-Produto-Formulario-Estoque-Ajuste>
  </div>
</template>

<style scoped>
.pro-form-est {
  width: 100%;
  max-width: 490px;
  margin: 0px auto;
  padding-top: 18px;
  text-align: left;
}
  .pro-form-est > div:not(:first-child) {
    padding-top: 14px;
  }
  .pro-form-est > div,
  .pro-form-est > div > div {
    width: 100%;
    margin-bottom: 0px;
  }
  
  .pro-form-est > .campos {
    width: 300px;
    margin: 0px auto;
  }
    .pro-form-est > .campos > .pro-form-det--est_calc {
      width: 130px;
    }
    .pro-form-est > .campos > .pro-form-det--qtde_min {
      width: calc(100% - 130px - 10px);
    }

    .pro-form-est > .campos > .pro-form-det--qtde_min {
      margin-left: 10px;
    }

  .pro-form-est > .demonstrativo {
    text-align: center;
  }
    .pro-form-est > .demonstrativo > .titulo {
      color: #777;
      font-weight: 600;
      border-bottom: 1px solid #eee;
    }

    .pro-form-est > .demonstrativo > .calculo {
      padding-top: 25px;
      border-bottom: 1px solid #eee;
    }
      .pro-form-est > .demonstrativo > .calculo > .parenteses {
        font-size: 20px;
        font-weight: bold;
        opacity: 0.75;
        display: inline-block;
        width: 20px;
        text-align: center;
        height: 30px;
        line-height: 28px;
      }
      .pro-form-est > .demonstrativo > .calculo > .sinais {
        width: 25px;
        text-align: center;
        margin-top: 0px;
        display: inline-block;
        opacity: .75;
      }
      
      .pro-form-est > .demonstrativo > .calculo > .cpnt-app-campo {
        width: calc((100% - 90px) / 3);
      }
      .pro-form-est > .demonstrativo > .passo-1 > .cpnt-app-campo {
        width: calc((100% - 120px) / 4);
      }

      .pro-form-est > .demonstrativo > .resultado {
        padding-top: 25px;
      }
      .pro-form-est > .demonstrativo > .resultado > .pro-form-det--qtde_est {
        width: 190px;
        margin: 0px auto;
      }

      .pro-form-est > .demonstrativo > .simbolos {
        padding-top: 10px !important;
        border: none !important;
      }
        .pro-form-est > .demonstrativo > .simbolos > div {
          height: 18px !important;
          line-height: 18px !important;
        }
    .pro-form-est > .aviso {
      text-align: center;
    }

    .pro-form-est > .demonstrativo > button {
      margin-top: 5px;
      padding: 5px 30px;
    }
</style>

<style>
.pro-form-est > .campos > .pro-form-det--est_calc > div {
  width: 100% !important;
}
.pro-form-est > .demonstrativo > .calculo > .sinais > span > span > svg {
  vertical-align: 0px;
}

.pro-form-est > .demonstrativo > .calculo > .cpnt-app-campo > label,
.pro-form-est > .demonstrativo > .resultado > .cpnt-app-campo > label {
  width: 100%;
  text-align: center;
}
.pro-form-est > .demonstrativo > .calculo > .cpnt-app-campo > input,
.pro-form-est > .demonstrativo > .resultado > .cpnt-app-campo > input {
  text-align: center;
}
.pro-form-est > .demonstrativo > .calculo > .cpnt-app-campo > input {
  border: none !important;
  background: none !important;
}


.pro-form-est > .demonstrativo > .passo-1 {
  padding-top: 40px !important;
}

.pro-form-est > .demonstrativo > .passo-3 {
  padding-top: 35px !important;
}
.pro-form-est > .demonstrativo > .calculo > .pro-form-det--qtde_dev_for > label,
.pro-form-est > .demonstrativo > .passo-1 > .cpnt-app-campo > label {
  margin-top: -15px;
}
/* .pro-form-est > .campos > .pro-form-det--qtde_min > label,
.pro-form-est > .campos > .pro-form-det--qtde_min > label > span {
  width: 160px;
} */
</style>

<script>
export default {
  props: {
    cpntHashId: {
      required: true
    },
    cpntId: {
      required: true
    },
    cpntEditarVarios: {
      required: true
    },
    cpntDados: {
      required: false,
      default: function () {
        return {}
      }
    },
    cpntValorAjusteNovo: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  components: {
    'App-Produto-Formulario-Estoque-Ajuste': () => import('@/components/produto/gerenciar/Formulario/Produto-Formulario-Estoque-Ajuste.vue')
  },
  data: function () {
    return {
      time: '',
      statusGeral: '',
      ajustarEst: false,
      dadosEst: null,
      campos: {
        est_calc: {
          id: this.cpntHashId + '--est_calc',
          status: '',
          tabIndex: 6003001,
          nome: 'Calcular Estoque?',
          value: true,
          keyValue: 'id',
          keyMostra: [ 'nome' ],
          apiEnv: 'est_calc',
          options: [
            { id: '0', nome: 'Não alterar a configuração do produto' },
            { id: '1', nome: 'Desativar o cálculo para todos os selecionados' },
            { id: '2', nome: 'Ativar o cálculo para todos os selecionados' }
          ],
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_min: {
          id: this.cpntHashId + '--qtde_min',
          status: '',
          tabIndex: 6003002,
          nome: 'Qtde. Mínima',
          value: '',
          valueIni: '',
          mask: 'VALOR_DECIMAL_CAMPO',
          apiEnv: 'qtde_min',
          onChange: this.proFormEstoqueOnChangeValue
        },

        est_ajuste: {
          id: this.cpntHashId + '--est_ajuste',
          status: '',
          tabIndex: 6003003,
          nome: 'Ajuste de Estoque',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_com: {
          id: this.cpntHashId + '--qtde_com',
          status: '',
          tabIndex: 6003004,
          nome: 'Qtde.<br/>Comprada',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_fab: {
          id: this.cpntHashId + '--qtde_fab',
          status: '',
          tabIndex: 6003005,
          nome: 'Qtde.<br/>Fabricado',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_dev_cli: {
          id: this.cpntHashId + '--qtde_dev_cli',
          status: '',
          tabIndex: 6003005,
          nome: 'Qtde.<br/>Dev. Cliente',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_con: {
          id: this.cpntHashId + '--qtde_con',
          status: '',
          tabIndex: 6003006,
          nome: 'Qtde. Consumido',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_dev_for: {
          id: this.cpntHashId + '--qtde_dev_for',
          status: '',
          tabIndex: 6003007,
          nome: 'Qtde.<br/>Dev. Fornecedor',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_ven: {
          id: this.cpntHashId + '--qtde_ven',
          status: '',
          tabIndex: 6003008,
          nome: 'Qtde. Vendida',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        qtde_est: {
          id: this.cpntHashId + '--qtde_est',
          status: '',
          tabIndex: 6003009,
          nome: 'Quantidade atual em estoque:',
          value: '0.00',
          valueIni: '0.00',
          disabled: true,
          mask: 'VALOR_DECIMAL_CAMPO',
          onChange: this.proFormEstoqueOnChangeValue
        },
        est_ajuste_api: {
          status: '',
          nome: '',
          value: '0.00',
          valueIni: '0.00',
          apiEnv: 'qtde_ini'
        },
      }
    }
  },
  mounted: function () {
    this.proFormEstoqueIniciar()
  },
  methods: {
    proFormEstoqueIniciar: function () {
      // SETA O STATUS DA PAGINA
      this.proFormEstoqueSetaStatusGeral('carregando')

      // VERIFICA SE ESTÁ EDITANDO UM PRODUTO
      if (typeof this.cpntId !== 'object' && this.cpntId >= 1) {
        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = [ 'est_calc', 'qtde_min' ]

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.proFormEstoqueSetarValorCampo(chave, this.cpntDados)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // SETA O STATUS DA PAGINA
        this.proFormEstoqueBuscarQuantidades()
      } else {
        // SETA OS DADOS RECEBIDOS
        this.dadosEst = Object.assign(this.cpntDados, { virtual_qtde_estoque: {
          id: "14525",
          estoque_ajuste: "0",
          qtde_min: "0.000",
          comprado: "0",
          dem_dev_cliente: "0",
          fabricado_na_fabricacao: "0",
          fabricado_na_venda: "0",
          fabricado: "0",
          consumido_na_fabricacao: "0",
          consumido_na_venda: "0",
          consumido: "0",
          vendido: "0",
          dem_dev_fornecedor: "0",
          estoque: "0"
        } })

        // SETA O STATUS DA PAGINA
        this.proFormEstoqueSetaStatusGeral('')
      }
    },
    proFormEstoqueSetaStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    proFormEstoqueSetarValorCampo: function (chave, dados) {
      // INICIA A VARIAVEL DE VALOR
      var value = ''
      var valueRef = ''
      var options = null

      // VERIFICA O VALOR QUE DEVE SELECIONAR
      switch (chave) {
        case 'est_calc':
          value = [ true, 'true', '1', 1, '', null, undefined ].indexOf(dados[chave]) !== -1
          break

        case 'qtde_min':
          value = dados[chave]
          break

        case 'est_ajuste':
        case 'est_ajuste_api':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.estoque_ajuste) !== -1) ? '0' : dados.virtual_qtde_estoque.estoque_ajuste
          break

        case 'qtde_com':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.comprado) !== -1) ? '0' : dados.virtual_qtde_estoque.comprado
          break

        case 'qtde_fab':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.fabricado) !== -1) ? '0' : dados.virtual_qtde_estoque.fabricado
          break

        case 'qtde_con':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.consumido) !== -1) ? '0' : dados.virtual_qtde_estoque.consumido
          break

        case 'qtde_dev_cli':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.dem_dev_cliente) !== -1) ? '0' : dados.virtual_qtde_estoque.dem_dev_cliente
          break

        case 'qtde_dev_for':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.dem_dev_fornecedor) !== -1) ? '0' : dados.virtual_qtde_estoque.dem_dev_fornecedor
          break

        case 'qtde_ven':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.vendido) !== -1) ? '0' : dados.virtual_qtde_estoque.vendido
          break

        case 'qtde_est':
          value = ([ '', null, undefined ].indexOf(dados.virtual_qtde_estoque) !== -1 || [ '', null, undefined ].indexOf(dados.virtual_qtde_estoque.estoque) !== -1) ? '0' : dados.virtual_qtde_estoque.estoque
          break
      }

      // PEGA OS OPTIONS DO CAMPO
      if (options === null && [ '', null, undefined ].indexOf(this.campos[chave].options) === -1 && this.campos[chave].options.length >= 1) {
        options = this.campos[chave].options
      }

      // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
      if (options !== null && options.length >= 1 && typeof value === 'string') {
        // PEGA O VALOR DO CAMPO
        var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

        // SETA O VALOR ENCONTRADO
        value = valor.length === 1 ? valor[0] : value
      }

      // SETA O VALOR ATUALIZADO DO CAMPO
      this.$set(this.campos[chave], 'value', value)
      this.$set(this.campos[chave], 'valueRef', valueRef)

      // VERIFICA SE TEM VALOR PARA ATUALIZAR
      if (options !== null) {
        this.$set(this.campos[chave], 'options', options)
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    proFormEstoqueOnChangeValue: function (value, id) {
      // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
      var indexF = id.split('--')

      // SETA O VALOR RECEBIDO
      this.$set(this.campos[indexF[1]], 'value', value)

      // LIMPA O CAMPO DE MENSAGEM DE ERRO
      this.$set(this.campos[indexF[1]], 'mensagem', '')

      // MANDA REMOVER A MENSAGEM DE ERRO DA ABA
      this.$emit('PRODUTO_FORMULARIO_REMOVER_ERRO', id)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // VERIFICA SE DEVE REALIZAR ALGUMA AÇÃO NO CAMPO
      switch (indexF[1]) {
        case 'est_calc':
          this.proFormEstoqueBuscarQuantidades()
          break

        case 'qtde_est':
          this.campos.est_ajuste_api.value = this.proFormEstoqueCalcularNovaQtdeInicial()
          break
      }
    },
    proFormEstoqueBuscarQuantidades: function () {
      if (this.campos.est_calc.value === true && typeof this.cpntId !== 'object' && this.cpntId >= 1) {
        // SETA OS DADOS 
        var queryGet = { ids: [ this.cpntId ], forcarEstoque: 's' }
  
        // FAZ A BUSCA DOS DADOS NA API
        this.$store.state.comunicaAPI('/produto/estoque/qtde/get/', 'GET', queryGet, (retorno) => {
          if (retorno.lot[0].code === '200') {
            // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
            var chaves = [ 'est_ajuste', 'qtde_com', 'qtde_fab', 'qtde_con', 'qtde_dev_for', 'qtde_dev_cli', 'qtde_ven', 'qtde_est' ]

            // SETA OS DADOS RECEBIDOS
            this.dadosEst = Object.assign(this.cpntDados, { virtual_qtde_estoque: retorno.lot[0].data })
    
            // RODA O VETOR DOS CAMPOS
            for (var indexC in chaves) {
              // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
              var chave = chaves[indexC]
    
              // SETA OS VALORES DO CAMPO
              this.proFormEstoqueSetarValorCampo(chave, this.dadosEst)
    
              // SETA O VALOR INICIAL DO CAMPO
              this.campos[chave].valueIni = this.campos[chave].value
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else {
            this.$store.state.TRATAR_RET_LOT_API(retorno)
          }

          // SETA O STATUS DA PAGINA
          this.proFormEstoqueSetaStatusGeral('')
        }, this.proFormEstoqueSetaStatusGeral)
      } else {
        // SETA OS DADOS RECEBIDOS
        this.dadosEst = Object.assign(this.cpntDados, { virtual_qtde_estoque: {
          id: "14525",
          estoque_ajuste: "0",
          qtde_min: "0.000",
          comprado: "0",
          dem_dev_cliente: "0",
          fabricado_na_fabricacao: "0",
          fabricado_na_venda: "0",
          fabricado: "0",
          consumido_na_fabricacao: "0",
          consumido_na_venda: "0",
          consumido: "0",
          vendido: "0",
          dem_dev_fornecedor: "0",
          estoque: "0"
        } })

        // SETA O STATUS DA PAGINA
        this.proFormEstoqueSetaStatusGeral('')
      }
    },
    proFormEstoqueCalcularNovaQtdeInicial: function () {
      // CARREGA OS VALORES
      var qtde_con      = Number(this.campos.qtde_con.value)
      var qtde_dev_for  = Number(this.campos.qtde_dev_for.value)
      var qtde_dev_cli  = Number(this.campos.qtde_dev_cli.value)
      var qtde_ven      = Number(this.campos.qtde_ven.value)
      var qtde_com      = Number(this.campos.qtde_com.value)
      var qtde_fab      = Number(this.campos.qtde_fab.value)
      var qtde_est      = Number(this.campos.qtde_est.value)

      // CALCULA A QUANTIDADE INICIAL
      var est_ajuste = (qtde_con + qtde_dev_for + qtde_ven - qtde_com - qtde_fab - qtde_dev_cli + qtde_est)

      // FORMATA A NUMERAÇÃO RECEBIDA
      est_ajuste = est_ajuste.toFixed(4)

      // RETORNA O VALOR CALCULADO
      return est_ajuste
    },
    proFormEstoqueAjustarEstoque: function () {
      if (this.cpntId === 0) {
        this.$emit('SALVAR_PRODUTO_ESTOQUE_AJUSTE')
      } else {
        // SETA SE DEVE ABRIR OU FECHAR A TELA DE AJUSTAR ESTOQUE
        this.ajustarEst = !this.ajustarEst
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    proFormEstoqueAjustarSalvar: function (formData) {
      this.$emit('PRODUTO_AJUSTE_ESTOQUE', formData)
    },
    proFormAtualizarInfoExterna: function () {
      // CHAMA A FUNÇÃO PARA INICIAR O PROCESSO
      this.proFormEstoqueBuscarQuantidades()

      // SETA COM A ATUALIZAÇÃO 
      this.$emit('ATUALIZAR_INFORMACOES_EXTERNAS')
    }
  }
}
</script>
